import React, { Component } from 'react'
import { connect } from 'react-redux'
import './styles.css'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import ReactTooltip from 'react-tooltip'
import Sidebar from 'react-sidebar'
import DocDrawer from './drawer'

class Documentation extends Component {
    state = {
        phase: 0,
        userAttributes: null,
        errorMessage: null,
        username: null,
        cognitoUser: null,
        disabled: true,
        changePasswordDisabled: true
    }

    render() {
        const sidebar = <DocDrawer />

        const sidebarProps = {
            sidebar: sidebar,
            docked: true,
            open: true,
            onSetOpen: null
        }

        let marginTopParagraph = '40px'

        return (
            <Sidebar {...sidebarProps}>
                <div className="">
                    <div className="doc-page" style={{ 'margin-bottom': '100px', 'text-align': 'left', padding: '20px', background: '#f1f2f7' }}>
                        <WhiteBox>
                            <div className="row" id="doc_integrations">
                                <div className="col">
                                    <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                        Revenue Reporting
                                    </h2>
                                    <p>
                                        <u>The revenue report is updated updated every 8 hours 3 times a day.</u>
                                        <br />
                                        <br />
                                        You can filter revenues by audience name, product and by date.
                                    </p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Report Dimensions
                                    </h3>
                                    <p>
                                        All the reports are <u>filtered by a date range</u>. The dimension of the report are:
                                        <ul>
                                            <li>
                                                <b>License</b>: the license name associated with this revenue. It has clickable link, so it's possible to search
                                                for this license.
                                            </li>
                                            <li>
                                                <b>Marketplace</b>: the Marketplace where the segment was activated and leveraged
                                            </li>
                                            <li>
                                                <b>Product</b>: the DMP product licensed (for example, DV360 or DFP for Publishers)
                                            </li>
                                            <li>
                                                <b>Audience</b>: the Audience associated to this license. It has clickable link, so it's possible to search for
                                                this audience.
                                            </li>
                                            <li>
                                                <b>Clicks</b>: the sum of the clicks registered for this audience for the date range selected
                                            </li>
                                            <li>
                                                <b>Impressions</b>: the sum of the Impressions registered for this audience for the date range selected
                                            </li>
                                            <li>
                                                <b>Revenue</b>: the amount in $ (USD) earned for the date range selected
                                            </li>
                                        </ul>
                                    </p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Invoicing
                                    </h3>
                                    <p>
                                        Send all Invoices with your contract header to <b>admin@audiencerate.com</b>
                                    </p>
                                </div>
                            </div>
                        </WhiteBox>
                    </div>
                </div>
            </Sidebar>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Documentation)
